// Cart count start
document.addEventListener('DOMContentLoaded', function () {
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(data => {
        const cartCount = data.item_count;
        const cartBubble = document.querySelector('.cart-link__bubble');

        if (cartCount > 0) {
          cartBubble.textContent = cartCount;
          cartBubble.classList.add('cart-link__bubble--visible');
        } else {
          cartBubble.classList.remove('cart-link__bubble--visible');
        }
      })
      .catch(error => console.error('Error fetching cart data:', error));
  }

  updateCartCount();
  document.addEventListener('cart:updated', updateCartCount);

  document.addEventListener('click', function (event) {
    if (
      event.target.matches('.add-to-cart-button') || 
      event.target.closest('button[data-add-to-cart]')
    ) {
      // Wait 3 seconds before fetching the updated cart data
      setTimeout(() => {
        fetch('/cart.js', { method: 'GET' })
          .then(response => response.json())
          .then(data => {
            const event = new CustomEvent('cart:updated');
            document.dispatchEvent(event);
          })
          .catch(error => console.error('Error adding item to cart:', error));
      }, 3000); // 3 seconds delay
    }
  });
});

// Cart count end

// "Back to Top" start
   window.onscroll = function() {
  let backToTopButton = document.getElementById("back-to-top");
  let cartButton = document.querySelector(".js-drawer-open-cart");
  
  // Check if the cart drawer is open
  let isCartOpen = cartButton && cartButton.getAttribute("aria-expanded") === "true";

  if ((document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) && !isCartOpen) {
    backToTopButton.style.display = "block";
  } else {
    backToTopButton.style.display = "none";
  }
      // console.log("Script loaded successfully!");
};

// Smooth scroll to top on button click
document.getElementById("back-to-top").onclick = function() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};
// "Back to Top" end

// carousel start
document.addEventListener("DOMContentLoaded", () => {
  // Find all carousel sections
  const carouselSections = document.querySelectorAll(".product-grid-slider");

  // Loop through each carousel section
  carouselSections.forEach((section) => {
    const carousel = section.querySelector(".carousel-container");
    const slides = section.querySelectorAll(".carousel-slide");
    const prevButton = section.querySelector("[data-carousel='prev']");
    const nextButton = section.querySelector("[data-carousel='next']");

    // Function to move the carousel
    function handleCarouselMove(positive = true) {
      // Calculate the total width of 3 items
      const slideWidth = slides[0].clientWidth; // Assuming all slides have the same width
      const moveDistance = slideWidth * 4;

      // Scroll the carousel
      carousel.scrollLeft = positive
        ? carousel.scrollLeft + moveDistance
        : carousel.scrollLeft - moveDistance;
    }

    // Attach event listeners to buttons
    prevButton.addEventListener("click", () => handleCarouselMove(false));
    nextButton.addEventListener("click", () => handleCarouselMove(true));
  });
});

// carousel end

// input field validation start
document.addEventListener("DOMContentLoaded", function () {
  const fields = [
    { selector: "#CustomerEmail", validate: validateEmailField },
    { selector: "#CustomerPassword", validate: validatePasswordField },
    { selector: "#RecoverEmail", validate: validateEmailField },
    { selector: "#FirstName", validate: (input) => validateTextField(input, "First name is required.") },
    { selector: "#LastName", validate: (input) => validateTextField(input, "Last name is required.") },
    { selector: "#Email", validate: validateEmailField },
    { selector: "#CreatePassword", validate: (input) => validateTextField(input, "Password is required.") }
  ];

  fields.forEach(({ selector, validate }) => {
    const field = document.querySelector(selector);
    if (field) {
      field.addEventListener("focus", () => clearErrorMessage(field));
      field.addEventListener("blur", () => validate(field));
    }
  });

  function validateTextField(input, message) {
    if (!input.value.trim()) {
      showErrorMessage(input, message);
    }
  }

  function validateEmailField(input) {
    if (!input.value.trim()) {
      showErrorMessage(input, "Email is required.");
    } else if (!validateEmail(input.value)) {
      showErrorMessage(input, "Please enter a valid email address.");
    }
  }

  function validatePasswordField(input) {
    if (!input.value.trim()) {
      showErrorMessage(input, "Password is required.");
    }
  }

  function showErrorMessage(input, message) {
    let error = input.nextElementSibling;
    if (!error || !error.classList.contains("error-message")) {
      error = document.createElement("div");
      error.classList.add("error-message");
      error.style.color = "red";
      input.parentNode.insertBefore(error, input.nextSibling);
    }
    error.textContent = message;
    input.classList.add("error");
  }

  function clearErrorMessage(input) {
    input.classList.remove("error");
    const error = input.nextElementSibling;
    if (error && error.classList.contains("error-message")) {
      error.remove();
    }
  }

  function validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  }
});

// input field validation end

// Remove default variant selection start
document.addEventListener('DOMContentLoaded', () => {
  // Select all variant input fields, the Add to Cart button, the Select Variant First button, and the Payment button
  const variantInputs = document.querySelectorAll('.variant-input input[data-variant-input]');
  const addToCartButton = document.querySelector('[data-add-to-cart]');
  const selectVariantFirstButton = document.querySelector('.select_variant_first_custom');
  const paymentButton = document.querySelector('[data-shopify="payment-button"]');

  // Ensure elements exist before applying logic
  if (variantInputs.length && addToCartButton && selectVariantFirstButton && paymentButton) {
    // Initially, show the "Select variant first" button and hide the "Add to Cart" and "Payment" buttons
    selectVariantFirstButton.style.display = 'block';
    addToCartButton.style.display = 'none';
    paymentButton.style.display = 'none';

    // Add event listener to each variant input
    variantInputs.forEach(input => {
      input.addEventListener('change', () => {
        // If a variant is selected, hide the "Select variant first" button and show the "Add to Cart" and "Payment" buttons
        if (Array.from(variantInputs).some(input => input.checked)) {
          selectVariantFirstButton.style.display = 'none';
          addToCartButton.style.display = 'block';
          paymentButton.style.display = 'block';
        }
      });
    });
  }
});

// Remove default variant selection end